/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { SdsDivProps } from '../Component.props';
import { SdsTextSize, SdsTextWeight } from './SdsText.types';

/**
 * The props for `<SdsText />`.
 */
export interface SdsTextProps extends SdsDivProps {
  /**
   * The custom HTML element tag to use.
   */
  customTag?: keyof JSX.IntrinsicElements;

  /**
   * The font size.
   */
  fontSize?: SdsTextSize;

  /**
   * The font weight.
   */
  fontWeight?: SdsTextWeight;

  /**
   * The text content.
   */
  text: string;
}

/**
 * The default prop values for `<SdsText />`.
 */
export const SdsTextDefaults = {
  customTag: `span` as keyof JSX.IntrinsicElements,
  fontSize: SdsTextSize.Medium,
  fontWeight: SdsTextWeight.Regular,
};
